/* CAFFREY Revive Wax Polish · page behaviour (Claude Code, launch agent, WORKFLOW-P builder, 2026-10-08).
   <cf-wp-buy>    shade radios -> the kit-compatible product form. No shade is preselected (LAUNCH-BRIEF bulletin 6
                  applied to shade: a wrong colour is this category's first fear). Only the shopper or a ?variant= link
                  chooses one. Until then Add to cart and Shop Pay (a transparent guard over Shopify's greyed button)
                  ask for a shade (message under the pills, scroll, focus), and the kit sticky bar reads
                  "Choose your shade" with an active Add to cart that presses the main button.
   <cf-wp-stage>  hero slider (native scroll-snap): follows the chosen shade, dots, zoom dialog (catalog image, 1080 px).
   [data-wp-pick] Shades section: choose that shade in the buy box (plain ?variant= links without JS).
   Phone hero: keeps the stage exactly one screen under the header (CSS default --cf-wp-top: 96px).
   Safe to load twice (defer). No dependencies; uses Dawn's <product-form> and the kit sticky bar when present. */
(function () {
  'use strict';
  if (window.CfWp) return;
  window.CfWp = { buy: null, stage: null };

  var reduced = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var designMode = function () { return !!(window.Shopify && window.Shopify.designMode); };
  var behavior = function () { return reduced() ? 'auto' : 'smooth'; };

  /* ---------------- buy box ---------------- */
  class CfWpBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.msg = this.querySelector('[data-wp-msg]');
      this.pick = this.querySelector('[data-wp-pick-set]');
      this.guard = this.querySelector('[data-wp-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[data-wp-shade]'));
      window.CfWp.buy = this;
      if (!this.radios.length) return; /* single-variant product: the plain form is enough */
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-wp-shade]')) self.select(e.target, true);
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no shade chosen, a
         click anywhere in the payment block asks for a shade instead. */
      var pay = this.querySelector('[data-wp-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-wp-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = !any;
      this.markPicks(null);
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) document.querySelectorAll('[data-wp-price]').forEach(function (el) { el.textContent = price; });
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      this.markPicks(r.value);
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
      document.dispatchEvent(new CustomEvent('cf-wp:shade', { detail: { id: r.value, user: !!byUser } }));
    }
    /* Shades section: choose a shade by its variant id. */
    choose(id) {
      var want = String(id);
      var r = null;
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].value === want) r = this.radios[i];
      if (!r) return false;
      r.checked = true;
      this.select(r, true);
      return true;
    }
    markPicks(id) {
      document.querySelectorAll('[data-wp-pick]').forEach(function (a) {
        if (id !== null && a.getAttribute('data-wp-pick') === String(id)) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
    /* "Choose a shade first.": message under the pills, pills outlined, scrolled into view, first shade focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = this.dataset.chooseError || '';
        this.msg.hidden = false;
      }
      if (this.pick) {
        this.pick.classList.remove('is-asking');
        void this.pick.offsetWidth; /* restart the outline when asked again */
        this.pick.classList.add('is-asking');
        var box = this.pick.getBoundingClientRect();
        if (box.top < 72 || box.bottom > window.innerHeight - 96) this.pick.scrollIntoView({ block: 'center', behavior: behavior() });
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.pick) this.pick.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it would read "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var want = r.getAttribute('data-title') || '';
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      if (btn && btn.disabled) btn.disabled = false;
      if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
      if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
    }
  }

  /* ---------------- hero slider ---------------- */
  class CfWpStage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      window.CfWp.stage = this;
      this.track = this.querySelector('[data-wp-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-wp-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-wp-dot]'));
      this.zoomBtn = this.querySelector('[data-wp-zoom]');
      this.dialog = this.querySelector('[data-wp-dialog]');
      if (!this.track || !this.slides.length) return;
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i, true); }); });
      var queued = false;
      this.track.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; self.mark(); });
      }, { passive: true });
      document.addEventListener('cf-wp:shade', function (e) {
        var i = self.indexOf(e.detail && e.detail.id);
        if (i >= 0) self.go(i, !!(e.detail && e.detail.user));
      });
      if (this.zoomBtn && this.dialog && typeof this.dialog.showModal === 'function') {
        this.zoomBtn.addEventListener('click', function () { self.zoom(); });
        this.dialog.addEventListener('click', function (e) {
          if (e.target === self.dialog || (e.target.closest && e.target.closest('[data-wp-close]'))) self.dialog.close();
        });
      } else if (this.zoomBtn) {
        this.zoomBtn.hidden = true;
      }
      /* The other shades load after the page (lazy images in a sideways scroller can load late on a swipe). */
      var warm = function () {
        self.slides.forEach(function (s) {
          var img = s.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        });
      };
      if (document.readyState === 'complete') setTimeout(warm, 1500);
      else window.addEventListener('load', function () { setTimeout(warm, 1500); }, { once: true });
      fitStage(this);
      window.addEventListener('resize', function () { fitStage(self); }, { passive: true });
    }
    indexOf(id) {
      for (var i = 0; i < this.slides.length; i++) if (this.slides[i].getAttribute('data-wp-slide') === String(id)) return i;
      return -1;
    }
    current() {
      var w = this.track.clientWidth || 1;
      return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w)));
    }
    go(i, smooth) {
      if (!this.slides[i]) return;
      var left = i * this.track.clientWidth;
      if (Math.abs(this.track.scrollLeft - left) > 1) {
        try { this.track.scrollTo({ left: left, behavior: smooth ? behavior() : 'auto' }); } catch (e) { this.track.scrollLeft = left; }
      }
      this.mark(i);
    }
    mark(i) {
      if (typeof i !== 'number') i = this.current();
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    zoom() {
      var s = this.slides[this.current()];
      if (!s) return;
      var img = this.dialog.querySelector('img[data-wp-zoom-img]');
      if (!img) {
        img = document.createElement('img');
        img.setAttribute('data-wp-zoom-img', '');
        img.width = 1080;
        img.height = 1080;
        img.decoding = 'async';
        this.dialog.appendChild(img);
      }
      img.alt = s.getAttribute('data-zoom-alt') || '';
      img.src = s.getAttribute('data-zoom');
      this.dialog.showModal();
    }
  }

  /* Phone: the stage is one screen tall under the header. CSS assumes a 96 px header (announcement bar + header);
     if this page's header measures differently, use the real value (no change, no layout shift, when it matches). */
  function fitStage(stage) {
    if (!stage || window.innerWidth >= 750 || window.scrollY > 4) return;
    var top = Math.round(stage.getBoundingClientRect().top + window.scrollY);
    var cur = parseFloat(getComputedStyle(stage).getPropertyValue('--cf-wp-top')) || 96;
    if (top > 40 && top < 260 && Math.abs(top - cur) > 3) stage.style.setProperty('--cf-wp-top', top + 'px');
  }

  /* Shades section: a tap on a tin or its name chooses that shade and brings the buy box into view. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-wp-pick]');
    if (!a || !window.CfWp.buy || typeof window.CfWp.buy.choose !== 'function') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    if (!window.CfWp.buy.choose(a.getAttribute('data-wp-pick'))) return;
    e.preventDefault();
    var phone = window.innerWidth < 750;
    var target = phone ? window.CfWp.buy : (document.getElementById('cf-wp-product') || window.CfWp.buy);
    target.scrollIntoView({ block: phone ? 'center' : 'start', behavior: behavior() });
  });

  [['cf-wp-buy', CfWpBuy], ['cf-wp-stage', CfWpStage]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
